export enum MachineTypeEnum {
    OFFICE = 1,
    MOBILE_FORCE = 2,
    ALLIED = 3,
    OFFICE_SELF_MANAGEMENT = 4,
    MOBILE_FORCE_AND_ALLIED = 5,
    MICROFINANCE = 6
}



// WEBPACK FOOTER //
// ./src/app/enums/machine-type.enum.ts